import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import router from './router';
import { RouterProvider } from 'react-router-dom';
import store from './store';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import initializeAuth from '@/utils/initializeAuth';
import { NotificationMonitor } from '@/components/notifications';

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = async () => {
  // HttpOnly Cookie 模式下先尝试恢复会话，避免受保护页面提前跳转。
  await initializeAuth(store);

  root.render(
    // ant Design 全局默认样式配置
    <ConfigProvider locale={zhCN} theme={{
      token: {
        colorPrimary: 'rgb(39, 38, 54)',
        colorLink: 'rgb(39, 38, 54)',
      },
      components: {
        Badge: { dotSize: 8 },
        Card: { borderRadiusLG: 8 },
        Modal: { borderRadiusLG: 16 },
        Alert: { borderRadiusLG: 8 },
        Popover: { borderRadiusLG: 8 },
        Tooltip: { borderRadius: 8 },
        Message: { borderRadiusLG: 8 },
        Notification: { borderRadiusLG: 8 },
        Select: {
          optionSelectedBg: 'transparent',
          optionSelectedColor: 'rgb(39, 38, 54)',
          optionSelectedFontWeight: 600,
        },
        Menu: {
          itemSelectedBg: 'transparent',
          horizontalItemSelectedBg: 'transparent',
        },
        Dropdown: {
          controlItemBgActive: 'transparent',
          controlItemBgActiveHover: 'transparent',
        },
        Pagination: {
          itemActiveBg: 'transparent',
        },
      },
    }}>
      {/* Redux 根store配置 */}
      <Provider store={store}>
        <NotificationMonitor />
        {/* Router 根路由配置 */}
        <RouterProvider router={router} >
          <React.StrictMode>
            <App />
          </React.StrictMode>
        </RouterProvider>
      </Provider>
    </ConfigProvider>
  );
};

renderApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
